import { Box, Button, Grid2, Typography } from "@mui/material";

const FILES_BASE = "https://kyc.getcupi.com/files/";
// ^ expose uploads statically on your server, e.g.
// app.use("/uploads", express.static(path.join(__dirname, "routes", "uploads")));

function formatBytes(n = 0) {
  if (n === 0) return "0 B";
  const k = 1024,
    sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(n) / Math.log(k));
  return `${(n / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
}

function DocsList({ docs = [] }) {
  if (!Array.isArray(docs) || docs.length === 0)
    return <Typography variant="body1">—</Typography>;
  return (
    <Box sx={{ display: "grid", gap: 0.5 }}>
      {docs.map((d) => {
        const link = d?.stored_filename
          ? `${FILES_BASE}/${encodeURIComponent(d.stored_filename)}`
          : null;
        return (
          <Box
            key={d?.document_id || d?.stored_filename}
            sx={{
              width: "40%",
              padding: "10px",
              display: "flex",
              gap: 1,
              alignItems: "center",
              border: "1px solid #E3E3E3",
              borderRadius: "8px",
              textAlign: "center",
            }}
          >
            {" "}
            <img src="/read.svg" />
            <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
              {d?.filename || d?.stored_filename || "Document"}
            </Typography>
            {link && (
              <Button
                size="small"
                variant="text" // or "outlined"/"contained"
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  ml: "auto", // <-- pushes to end
                  color: "#FFFFFF",
                  backgroundColor: "#2348AB",
                  textTransform: "none",
                }}
              >
                View
              </Button>
            )}
          </Box>
        );
      })}
    </Box>
  );
}

function DetailRow({ label, value }) {
  return (
    <Grid2 item xs={12} sm={12} md={12}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "120px 8px 1fr", sm: "150px 8px 1fr" },
          alignItems: "baseline",
          columnGap: 1,
          py: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: "#4C4E64", fontWeight: 600, whiteSpace: "nowrap" }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "#4C4E64", fontWeight: 600, whiteSpace: "nowrap" }}
        >
          :
        </Typography>

        {/* allow strings OR custom nodes */}
        <Box>
          {typeof value === "string" || typeof value === "number" ? (
            <Typography variant="body1">{value}</Typography>
          ) : (
            value
          )}
        </Box>
      </Box>
    </Grid2>
  );
}

export default function PreviewAdvanceKyc({ data }) {
  console.log("heyyy", data);

  const row = data || {};
  const docs = Array.isArray(row.attached_documents)
    ? row.attached_documents
    : [];

  return (
    <div className={`container`}>
      <div
        role="alert"
        style={{
          width: "100%",
          backgroundColor: "#C5F9DD",
          border: "1px solid #C5F9DD",
          borderRadius: 12,
          padding: "20px 24px",
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <div
          style={{
            maxWidth: 720,
            width: "100%",
            margin: "0 auto",
            textAlign: "left", // default left
          }}
        >
          {/* Title centered */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // ✅ centers horizontally
              gap: 8,
              marginBottom: 8,
              color:"#0F8445"
            }}
          >
            <img
              src="/approved.svg"
              alt=""
              style={{
                /* width: 20, height: 20, */ display: "inline-block",
              }}
            />
            {`ADVANCED KYC APPROVED`}
          </div>
        </div>
      </div>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, mt: 2 }}>
        Director/LLP/Partner/Proprietor/Authorized Signatory details
      </Typography>
      <Box
        component="hr"
        sx={{ border: 0, borderTop: "1px solid #e5e7eb", mb: 2 }}
      />
      <div>
        <Grid2 spacing={0.5} sx={{ mb: 2, mt: 2 }}>
          <DetailRow label="Name" value={row.name || "—"} />
          <DetailRow label="Designation" value={row.designation || "—"} />
          <DetailRow label="Phone no" value={row.phone || "—"} />
          <DetailRow label="Email ID" value={row.email || "—"} />
          <DetailRow label="Documents" value={<DocsList docs={docs} />} />
        </Grid2>
      </div>
    </div>
  );
}
